import { useEffect, useState } from "react";
import useSWR from "swr";
import { parse } from "date-fns";
import { useParams } from "react-router-dom";
import Loader from "../../../../components/Feedback/Loader";
import baseService from "../../../../services/base";
import PeriodicEditForm from "./Form";
import { Flex } from "@chakra-ui/react";

async function fetchArrayData(url) {
  const response = await baseService.get(url);
  return response?.data;
}

export default function PeriodicEdit() {
  const { id: surveyId } = useParams();

  const [pillarsUndefined, setPillarsUndefined] = useState(false);
  const [isFormUpdated, setIsFormUpdated] = useState(false);
  const [defaultValues, setDefaultValues] = useState();

  const { data, isLoading, mutate } = useSWR(
    surveyId ? `survey/periodic/${surveyId}` : null,
    fetchArrayData
  );

  useEffect(() => {
    const fetchData = async () => {
      if (data && data?.pillars?.length && !isFormUpdated) {
        const sortedPillars = data?.pillars?.sort(
          (a, b) => a.id_pillar - b.id_pillar
        );
        const transformedPillars = sortedPillars.map((pillar) => ({
          pillarId: pillar?.id_pillar,
          pillarName: pillar?.name_pillar,
          numberOfThemes: pillar?.themes?.length.toString(),
          themes: pillar?.themes?.map((theme) => ({
            ...theme,
            questions: theme?.questions
          })),
        }));

        const startDate = data?.period?.start_date
          ? parse(data?.period?.start_date, "yyyy-MM", new Date())
          : null;
        const endDate = data?.period?.end_date
          ? parse(data?.period?.end_date, "yyyy-MM", new Date())
          : null;

        setDefaultValues({
          name: data.description,
          form: transformedPillars,
          startDeadline: startDate,
          endDeadline: endDate,
          noEndDeadline: endDate ? false : true,
        });
        setIsFormUpdated(true);
      } else if (data && !data?.pillars && !isFormUpdated) {
        const startDate = data?.period?.start_date
          ? parse(data?.period?.start_date, "yyyy-MM", new Date())
          : null;
        const endDate = data?.period?.end_date
          ? parse(data?.period?.end_date, "yyyy-MM", new Date())
          : null;

        setDefaultValues({
          name: data.description,
          form: [],
          startDeadline: startDate,
          endDeadline: endDate,
        });
        setPillarsUndefined(true);
        setIsFormUpdated(true);
      }
    };

    fetchData();
  }, [data, surveyId, isFormUpdated]);

  if (isLoading || !isFormUpdated || !defaultValues) {
    return <Loader />;
  }

  return (
    <PeriodicEditForm
      defaultValues={defaultValues}
      data={data}
      mutate={mutate}
    />
  );
}
